//This class defines nicu display parameters.
export class DisplayParms {
    Page: number = 1;
    ResetShowFlag: boolean = false;
}